import React from 'react'
import { useSelector } from 'react-redux'

const Experiences = () => {
    const experiences = useSelector(state => state.experiences.payload);
    console.log(experiences);
  return (
    <div className='row justify-content-center p-5'
    id='experience'
    style={{ 
        backgroundColor: '#202421',
        color: 'white',
        // height: '800px'
     }}
    >
        <p className='small-header mt-2 text-center'> RECENT EXPERIENCES  </p>
        
            {
                experiences.map((experience) => (
                    
                <div className='col-lg-4 col-md-4 col-sm-6 col-xs12 experience'>
                    <div className='card mb-3 body' style={{ 
                        
                        padding: '5px'
                        }}>
                          <div className='d-flex justify-content-flex-start'>
                                <span className='d-flex justify-content-flex-start align-items-center'
                                style={{ 
                                    borderRadius:'100%',
                                width: '100px',
                                height: '100px'
                                }}
                                > 
                                <img src={experience.img} width={'80px'} height={'80px'} 
                                alt={experience.title}
                                style={{ 
                                    borderRadius: '100%',
                                    backgroundColor: 'black'
                                }}
                                />
                                </span>
                          </div>
                          <p className='ms-2'
                          style={{ 
                            fontSize: 13,
                            textAlign: 'justify'
                           }}
                          > {experience.remark} </p> 
                          <p className='ms-2 mb-0'> <b>{experience.title }</b> </p>
                          <p className='ms-2 mt-0 company'
                          > <b>{experience.company}</b> </p>
                          <p className='role'>
                            {experience.role}
                          </p>
                          <p  className='description'> 
                            <i> {experience.description} </i>
                          </p>
                          <p  className='date'> 
                            <i> {experience.date} </i>
                          </p>
                    </div>
                </div>
                ))
            }
        
        
        <div className='col-lg-4 col-md-4 col-sm-6 col-xs12'>

        </div>
    </div>
  )
}

export default Experiences